import { useEffect, useState } from 'react'

/** True once the page has been scrolled past `offset` pixels. */
const useScrolled = (offset = 12) => {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > offset)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [offset])

  return scrolled
}

export default useScrolled
